module.exports = __webpack_public_path__ + "static/media/moon.e5a33f9b.png";